import { Accordion, AccordionSummary, Box, Divider, Typography } from '@mui/material';
import { getProductTitle } from '@vy/services';
import type { FixedLineItem } from '@vy/types';
import { DEFAULT_CURRENCY } from '@vy/types';
import React from 'react';
import { Price } from '../../../../components/design/Price';
import { useDynamicInvoice } from '../dynamic-invoice-context';

type DynamicInvoicePromotionLineItemProps = {
  promotionLineItem: FixedLineItem;
  showDivider: boolean;
};

export const DynamicInvoicePromotionLineItem: React.FC<DynamicInvoicePromotionLineItemProps> = ({
  promotionLineItem: lineItem,
  showDivider,
}) => {
  const { total } = lineItem.revenueBreakdown;

  const { dynamicInvoiceData } = useDynamicInvoice();
  const currency = dynamicInvoiceData.customer.settings?.currency ?? DEFAULT_CURRENCY;

  return (
    <>
      <Accordion>
        <AccordionSummary>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ width: 387, paddingY: 4, flexDirection: 'column', gap: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 400,
                  fontSize: "16px"
                }}>
                {lineItem.modifiedName ?? getProductTitle(lineItem.lineItemProduct)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                marginRight: '35px',
              }}
            >
              <Typography variant="body2" sx={{ color: 'rgba(27, 61, 85, 0.60)', textAlign: 'right' }}>
                Amount
              </Typography>
              <Price variant="h6" currency={currency} fractionDigits={2}>
                {total}
              </Price>
            </Box>
          </Box>
        </AccordionSummary>
      </Accordion>
      {showDivider && <Divider />}
    </>
  );
};
